<template>
  <div class="fifth" :style="{height:screenHeight}" style="position: relative">
    <span class="fifthTitle" :class="activeShow===5?'animate__animated animate__bounceInUp':''">商家入驻</span>
    <span class="fifthSubtitle" :class="activeShow===5?'animate__animated animate__bounceInUp':''">现已累计有<font class="fifthNumber">【150万】</font>位商家入驻</span>
    <ul class="fifthForm" :class="activeShow===5?'animate__animated animate__fadeInRightBig animate__faster':''">
      <li>
        <span>企业名称</span>
        <van-field v-model="form.comName" placeholder="请输入企业名称"/>
      </li>
      <!-- <li>
        <span>经营类型</span>
        <van-field v-model="form.type" placeholder="请输入经营类型"/>
      </li> -->
      <li>
        <span>联系电话</span>
        <van-field v-model="form.comTel" placeholder="请输入联系电话"/>
      </li>
      <li>
        <span>详细地址</span>
        <van-field v-model="form.comAddress" placeholder="请输入详细地址"/>
      </li>
    </ul>
    <span class="fifthDesc" :class="activeShow===5?'animate__animated animate__pulse':''">*我们谨遵互联网隐私法，您的私人信息将得到严格保密，请放心填写</span>
    <div class="width100 float-left" @click="onSubmit">
      <span class="regNow">
        立即注册
      </span>
    </div>
    <div class="width100 text-center">
      <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/down_arrow.png" class="downButton" @click="moveSectionDown" style="margin-top:8% !important;">
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  export default {
    name: 'fifthPage',
    data(){
      return {
        screenHeight:0,
        screenWidth:0,
        form:{
          comName: '',
          comTel: '',
          comAddress: ''
        }
      }
    },
    props: {
      activeShow: Number
    },
    mounted(){

    },
    created(){
      this.screenHeight = document.documentElement.clientHeight+'px';
      this.screenWidth = document.documentElement.clientWidth+'px';
    },
    methods:{
      // 翻页方法 子传父
      moveSectionDown(){
        this.$emit('moveSectionDown');
      },
      onSubmit() {
      if(this.form.comName==''||this.form.comTel==''||this.form.comAddress ==''){
        alert('请完善信息')
      }else{
        var joinAddValue = {}
        joinAddValue.phone = this.form.comTel
        joinAddValue.name = this.form.comName
        joinAddValue.addressDetail = this.form.comAddress
        joinAddValue.cityCode = '000'
        axios.get('http://api.365paotui.cn:8090/OrderAppServer/h5ActivityController/joinAdd1.do',{params: joinAddValue}).then((res)=>{ 
          if(res.data.errorcode == '100'){
            alert('您已注册成功');
            window.location.reload()
          }
        })
      }
    },
    }
  }
</script>
<style>

</style>
